import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ApplicationModuleService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/applicationmodule').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getClientModules(clientShortName: string): Observable<ApplicationModule[]> {
        const params = new HttpParams().set('clientShortName', clientShortName);
        return this.http.get<ApplicationModule[]>(this._url + '/access/client', { params: params });
    }

    updateClientModule(modules: ClientModuleForm[], clientShortName: string): Observable<any> {
        let data: ClientModuleUpdateForm = {
            clientShortName: clientShortName,
            modules: modules,
        };

        return this.http.post<any>(this._url + '/access/client', data);
    }
}

export interface ApplicationModule {
    clientApplicationModuleKey: number;
    applicationModuleKey: number;
    minimumRoleKey?: number;
    activeDate?: Date;
    inActiveDate?: Date;
    isActive: boolean;
    lastMod?: Date;
    pages?: ApplicationModulePage[];
    moduleName: string;
}

export interface ApplicationModulePage {}

export interface ClientModuleUpdateForm {
    clientShortName: string;
    modules: ClientModuleForm[];
}

export interface ClientModuleForm {
    applicationModuleKey: number;
    clientApplicationModuleKey: number;
    isActive: boolean;
}
